import type { FunctionComponent, } from "react"
import styled from "styled-components"
import { Typography, type Variant, } from "@bracket/ui";

//@ts-ignore - remove if props added
export declare type ValueCellProps = {
	value: string|number|bigint;
	variant?: Variant;
};


export const ValueCell: FunctionComponent<ValueCellProps> = ({
	value,
	variant = "p",
}) => {

	const v = value === null ? "-" : value;

	return (
		<Brace>
			<Typography variant={variant}>{v.toString()}</Typography>
		</Brace>
	);

}


const Brace = styled.div`

`
